import { Flex, Spacing } from '@billy/design-system'

import { SalesByValueReportItem } from '../../types/salesByValueReportItem'
import { SalesReportSummary as SalesReportSummaryProps } from '../../types/salesReportSummary'
import { SalesReportStatisticsContextProvider } from './contexts/salesReportStatisticsContext'
import { SalesReportGraph } from './elements/SalesReportGraph'
import { SalesReportSummary } from './elements/SalesReportSummary'
import { SalesReportStatisticsVariant } from './types/salesReportStatisticsVariant'

type SalesReportVariantMap = {
  'by-item': SalesByValueReportItem[]
  'by-customer': SalesByValueReportItem[]
  overview: SalesReportSummaryProps[]
} & Record<SalesReportStatisticsVariant, unknown>

interface SalesReportStatisticsProps<T extends SalesReportStatisticsVariant> {
  isLoading: boolean
  salesReport: SalesReportVariantMap[T]
  variant: T
}

export const SalesReportStatistics = <T extends SalesReportStatisticsVariant>({
  isLoading,
  salesReport,
  variant,
}: SalesReportStatisticsProps<T>) => {
  return (
    <SalesReportStatisticsContextProvider isLoading={isLoading} salesReport={salesReport} variant={variant}>
      <Flex gap={Spacing.S8} justifyContent="flex-start">
        <SalesReportSummary />
        <SalesReportGraph />
      </Flex>
    </SalesReportStatisticsContextProvider>
  )
}
